import { NgModule } from '@angular/core';
import { RouterModule, Routes, UrlMatcher, UrlMatchResult, UrlSegment } from '@angular/router';
import { AuthenticationGuard } from './core/guards/authentication.guard';
import { NotFoundComponent } from './shared/components/notfound/pages/notfound.component';

const routes: Routes = [
  {
    path: 'mapa',
    loadChildren: () =>
      import('./features/mapa/mapa.module').then((module) => module.MapaModule),
  },
  {
    path: 'accessdenied',
    loadChildren: () =>
      import('./shared/components/accessdenied/accessdenied.module').then((module) => module.AccessDeniedModule),
  },
  {
    path: 'notfound',
    loadChildren: () =>
      import('./shared/components/notfound/notfound.module').then((module) => module.NotFoundModule),
  },
  {
    path: 'portal',
    loadChildren: () =>
      import('./features/portal/portal.module').then((module) => module.PortalModule),
  },

  { path: '**', component: NotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload', useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
